import { render } from "./NoteFormDialog.vue?vue&type=template&id=8d3a07b6&scoped=true"
import script from "./NoteFormDialog.vue?vue&type=script&lang=js"
export * from "./NoteFormDialog.vue?vue&type=script&lang=js"

import "./NoteFormDialog.vue?vue&type=style&index=0&id=8d3a07b6&scoped=true&lang=css"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d3a07b6"]])

export default __exports__